import { z } from 'zod';

export const equityInvestmentPageVisitedPostRequestSchema = z.object({});
